import _ from 'lodash';
import React from 'react';
import Blocklink from '../elements/Blocklink/Blocklink';
import LeftTabbedGrayHeader from '../elements/headers/LeftTabbedGrayHeader';
import HomeLogo from '../elements/HomeLogo';
import ParticipantListItem from '../elements/ParticipantListItem/ParticipantListItem';
import Scrollable from '../elements/Scrollable';
import TopBar from '../elements/TopBar/TopBar';
import Screen from './Screen';

export default class EventParticipantDisambiguation extends React.Component {
    render() {
        let { matches, i18n } = this.props;

        let header = (
            <div>
                <TopBar returnURL="/"></TopBar>
                <HomeLogo></HomeLogo>
                <hr />
            </div>
        );

        let list = _([matches.exact_match, ...matches.fuzzy_matches])
            .compact()
            .value();

        let alternatives;
        if (list.length) {
            alternatives = (
                <div>
                    <LeftTabbedGrayHeader>{i18n['label.participants']}</LeftTabbedGrayHeader>
                    <div className="content">
                        <p>
                            <b>{i18n['message.participants.header']}</b>
                        </p>
                    </div>
                    <div className="indent list">
                        {list.map((participant, i) => (
                            <ParticipantListItem className="clickable" participant={participant} key={i} onClick={this.handleSelectParticipant.bind(this, participant)} />
                        ))}
                    </div>
                </div>
            );
        }

        return (
            <Screen header={header}>
                <Scrollable>
                    {alternatives}
                    <Blocklink className="marginTop" next="next" onClick={this.handleNotOnList.bind(this)}>
                        {i18n['label.I.m.not.on.this.list']}
                    </Blocklink>
                    <br />
                    <br />
                </Scrollable>
            </Screen>
        );
    }

    handleNotOnList() {
        app.store.dispatch(app.actions.participants.needsDisambiguation(this.props.eventId));
    }

    handleSelectParticipant(participant) {
        app.api.events
            .alias(this.props.eventId, participant.id)
            .then((answer) => {
                console.log(answer);
            })
            .catch((error) => {
                console.error(error);
            })
            .then((answer) => {
                app.store.dispatch(app.actions.participants.needsDisambiguation(this.props.eventId));
            });
    }
}
